/** Clear Outline / Set 1. Shared vector geometry for toolbar, canvas and SVG DOM. */
export const WORLD_MAP_OBJECTS = [
  {
    kind: 'topic',
    name: 'Topic',
    paths: [
      {
        d: 'M32 34 V55 M24 55 H40',
        detail: true,
      },
      {
        d: 'M12 10 H44 L53 22 L44 34 H12 Q9 34 9 31 V13 Q9 10 12 10 Z',
        detail: false,
      },
      {
        d: 'M18 22 H37',
        detail: true,
      },
    ],
  },
  {
    kind: 'data-store',
    name: 'Data Store',
    paths: [
      {
        d: 'M12 16 C12 5 52 5 52 16 V48 C52 59 12 59 12 48 Z',
        detail: false,
      },
      {
        d: 'M 12.0 16.0 A 20.0 8.0 0 1 0 52.0 16.0 A 20.0 8.0 0 1 0 12.0 16.0 Z',
        detail: true,
      },
      {
        d: 'M12 32 C12 43 52 43 52 32',
        detail: true,
      },
    ],
  },
  {
    kind: 'user-io',
    name: 'User',
    paths: [
      {
        d: 'M22 55 V44 C15 40 12 34 12 26 C12 15 20 9 31 9 C41 9 47 15 47 24 L53 34 H46 V40 Q46 45 40 45 H35 V55 Z',
        detail: false,
      },
      {
        d: 'M 36.5 25.0 A 1.5 1.5 0 1 0 39.5 25.0 A 1.5 1.5 0 1 0 36.5 25.0 Z',
        detail: true,
      },
    ],
  },
  {
    kind: 'agent',
    name: 'Agent',
    paths: [
      {
        d: 'M 49.55,24.73 L 50.48,27.56 L 56.56,27.32 L 56.56,36.68 L 50.48,36.44 L 49.55,39.27 L 49.55,39.27 L 48.20,41.93 L 52.68,46.05 L 46.05,52.68 L 41.93,48.20 L 39.27,49.55 L 39.27,49.55 L 36.44,50.48 L 36.68,56.56 L 27.32,56.56 L 27.56,50.48 L 24.73,49.55 L 24.73,49.55 L 22.07,48.20 L 17.95,52.68 L 11.32,46.05 L 15.80,41.93 L 14.45,39.27 L 14.45,39.27 L 13.52,36.44 L 7.44,36.68 L 7.44,27.32 L 13.52,27.56 L 14.45,24.73 L 14.45,24.73 L 15.80,22.07 L 11.32,17.95 L 17.95,11.32 L 22.07,15.80 L 24.73,14.45 L 24.73,14.45 L 27.56,13.52 L 27.32,7.44 L 36.68,7.44 L 36.44,13.52 L 39.27,14.45 L 39.27,14.45 L 41.93,15.80 L 46.05,11.32 L 52.68,17.95 L 48.20,22.07 L 49.55,24.73 Z',
        detail: false,
      },
      {
        d: 'M 24.0 32.0 A 8.0 8.0 0 1 0 40.0 32.0 A 8.0 8.0 0 1 0 24.0 32.0 Z',
        detail: true,
      },
    ],
  },
  {
    kind: 'ai',
    name: 'AI',
    paths: [
      {
        d: 'M32 12 C26 7 19 10 18 17 C10 16 7 23 11 29 C5 35 9 43 16 44 C16 53 26 57 32 51 C38 57 48 53 48 44 C55 43 59 35 53 29 C57 23 54 16 46 17 C45 10 38 7 32 12 Z',
        detail: false,
      },
      {
        d: 'M32 12 V51 M18 17 C18 23 22 25 26 24 M11 29 C17 26 23 30 23 35 M16 44 C21 45 26 42 26 38 M46 17 C46 23 42 25 38 24 M53 29 C47 26 41 30 41 35 M48 44 C43 45 38 42 38 38',
        detail: true,
      },
    ],
  },
  {
    kind: 'document',
    name: 'Document',
    paths: [
      {
        d: 'M16 8 H37 L49 20 V56 H16 Z',
        detail: false,
      },
      {
        d: 'M37 8 V20 H49 M23 30 H42 M23 38 H42 M23 46 H36',
        detail: true,
      },
    ],
  },
  {
    kind: 'rule-book',
    name: 'Rule Book',
    paths: [
      {
        d: 'M17 8 H49 V48 H17 Q11 48 11 54 V14 Q11 8 17 8 Z',
        detail: false,
      },
      {
        d: 'M17 8 V48 M49 48 V56 H17 Q11 56 11 52 M18 52 H43',
        detail: true,
      },
    ],
  },
  {
    kind: 'tool',
    name: 'Tool',
    paths: [
      {
        d: 'M13.544 5.222 C19.203 4.482 25.379 9.734 24.603 17.205 C24.27 18.352 24.936 19.351 25.712 20.127 L46.499 40.951 Q47.534 41.986 48.163 42.245 C53.822 40.618 59 44.834 59 50.567 C59 55.301 55.301 59 50.493 59 C44.575 59 40.396 53.822 42.171 48.163 Q42.171 47.534 40.877 46.425 L19.61 25.379 Q18.5 24.307 17.279 24.603 C10.326 26.082 4.26 20.904 5.148 13.692 Q5.222 12.619 5.999 13.174 L10.252 17.316 Q11.842 18.685 13.433 17.39 L17.095 13.729 C18.241 12.582 18.13 11.251 17.39 10.4 L13.137 6.295 Q12.508 5.555 13.544 5.222 Z',
        detail: false,
      },
      {
        d: 'M49.199 46.055 L53.822 47.312 L54.932 51.751 L51.677 55.005 L47.164 53.748 L45.944 49.31 Z',
        detail: true,
      },
    ],
  },
  {
    kind: 'human-io',
    name: 'Human Control',
    paths: [
      {
        d: 'M22 26 V34 C22 40 26 45 28 46 V49 Q20 50 20 56 H44 Q44 50 36 49 V46 C38 45 42 40 42 34 V26',
        detail: false,
      },
      {
        d: 'M19 21 L16 12 Q32 3 48 12 L45 21 Z',
        detail: false,
      },
      {
        d: 'M19 21 H45 V26 H19 Z M19 26 Q32 32 45 26 M32 11 V18 M30 13 H34 M29 16 Q32 20 35 16 M28 33 H29 M35 33 H36 M32 35 V38 H34 M28 42 Q32 44 36 42',
        detail: true,
      },
      {
        d: 'M7 31 H15 M11 31 V43 M7 43 H15 M55 31 C49 31 49 43 55 43 C61 43 61 31 55 31 Z',
        detail: true,
      },
    ],
  },
] as const;
export type WorldMapKind = (typeof WORLD_MAP_OBJECTS)[number]['kind'];
export function getWorldMapObject(kind: string | undefined) {
  return WORLD_MAP_OBJECTS.find(object => object.kind === kind);
}

export const WORLD_MAP_STROKE = { light: '#cccccc', dark: '#333333' };
